import React, { useEffect, useState } from 'react'
import './bpCount.css'
import ButtonWrapper from '../../../widgets/button/button'
import ModalWrapper from '../../../widgets/modal/modal'
import AddBordingPassCount from '../../../componant/addBordingPassCount/addBordingPassCount'
import AgGridContainer from '../../../componant/gridContainer/gridContainer'
import { getAttendance, getBPCount } from '../../../api-services/employee-services'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

interface LoggedTimeProps {
  clockInDate: string;
  clockIn: string;
  clockOut: string;
  workingHours: string;
}

const BpCount = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loggedTime, setLoggedTime] = useState<LoggedTimeProps>({
    clockIn: '',
    clockOut: '',
    workingHours: '',
    clockInDate: ''
  })
  const [rowData, setRowData] = useState<any[]>([])

  const handleClose = () => {
    setOpenModal(false)
  }

  const onAddCount = () => {
    setOpenModal(true)
  }

  const fetchBPCount = () => {
    getBPCount().then((response: any) => {
      if (response?.status === 200) {
        console.log(response.data)
        setRowData(response.data)
      }
    })
  }

  useEffect(() => {
    fetchBPCount()
  }, [])

  useEffect(() => {
    getAttendance().then((response: any) => {
      if (response?.data.success) {
        const today = new Date()
        const todayFormatted = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`
        const todayRecord = response.data.payload.find((item: any) => item.clockInDate === todayFormatted)
        if (todayRecord) {
          setLoggedTime(todayRecord)
        }
      }
    })
  }, [])

  const lastAddedDate = rowData.length > 0
    ? rowData.reduce((latest: any, item: any) => (!latest || new Date(item.date) > new Date(latest.date) ? item : latest), null)?.date
    : ''

  const [columnDefs] = useState([
    {
      headerName: 'Date',
      field: 'date',
      minWidth: 130,
      flex: 1,
      resizable: true,
      filter: true,
      valueFormatter: (params: any) => {
        if (!params.value) return '';

        const [date, time] = params.value.split('T');
        const [year, month, day] = date.split('-');

        return `${day}/${month}/${year} ${time?.substring(0, 8)}`;
      }
    },
    {
      headerName: 'Count',
      field: 'count',
      minWidth: 130,
      flex: 1,
      resizable: true,
      filter: true,
    }
  ])

  return (
    <div className='main'>
      <div className='main-container'>
        <div className='heading heading-center-space-between height-40'>
          <h2>Boarding Pass Count</h2>
          <div className='flex-end-center'>
            <ButtonWrapper buttonType='circle' className='circular-add-button' onClick={onAddCount} tooltipPlacement='left' tooltipTitle='Add Count' />
          </div>
          <ModalWrapper open={openModal} close={handleClose} children={
            <AddBordingPassCount
              onClose={handleClose}
              onAdded={fetchBPCount}
              title='Add Boarding Pass Count'
              summary={{
                clockIn: loggedTime.clockIn,
                clockOut: loggedTime.clockOut,
                workingHours: loggedTime.workingHours,
                clockInDate: loggedTime.clockInDate
              }}
            />
          } />
        </div>
        <div className='cal-40'>
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className='bp-count-table-header'>
              <span className='bp-count-tip'>* Only added your working hour count, not overtime hour count</span>
              <span className='bp-count-last-added'>
                <span className='bp-count-last-added-label'>Last Added Date</span>
                <span className='bp-count-last-added-value'>{lastAddedDate ? dayjs.utc(lastAddedDate).format('DD/MM/YYYY') : '--'}</span>
              </span>
            </div>
            <div className='ag-grid-container' style={{ flex: 1 }}>
              <AgGridContainer rowData={rowData} columnDefs={columnDefs} />
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default BpCount
